import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { RegularButton as Button, Adaptive } from 'fronton-react';
import { catalogueLevels, FORM_NAME } from '../../const';
import { DataContext } from '../../../../entries/common/widgets/door-project/context';
import { Container } from './styles';

const DoorProjectFooter = ({ wide }: { wide?: boolean }) => {
  const data = useContext(DataContext);
  const { watch } = useFormContext();
  const currentValues = watch();
  const isNotValid = Object.values(currentValues).every(value => value === null || value.length === 0);
  const buttonText = data?.catalogueLevel === catalogueLevels.THIRD ? 'Применить' : 'Выбрать тип двери';

  return (
    <Button
      role="button"
      size="l"
      disabled={isNotValid}
      wide={wide}
      variant="primary"
      label={buttonText}
      type="submit"
      form={FORM_NAME}>
      {buttonText}
    </Button>
  );
};

export const Footer = () => (
  <Container>
    <Adaptive to="tablet">
      <DoorProjectFooter wide />
    </Adaptive>
    <Adaptive from="tablet">
      <DoorProjectFooter />
    </Adaptive>
  </Container>
);
